import fetch from '../../../../utils/fetch'

const getInitialState = () => {
  return {
    isLoading: false,
    projectDownloads: null,
    error: null,
  }
}

const state = getInitialState();

const getters = {
  isLoading(state) {
    return state.isLoading
  },
  projectDownloads(state) {
    return state.projectDownloads
  },
  error(state) {
    return state.error
  },
}

const actions = {
  create({commit, dispatch}, data) {
    commit(types.SET_PROJECT_DOWNLOADS_LOADING)
    return fetch('/project_downloads', { method: 'POST', body: JSON.stringify(data) })
      .then(response => response.json())
      .then((data) => {
        dispatch('get', null, {root: false})
        return data
      })
      .catch((error) => {
        commit(types.SET_PROJECT_DOWNLOADS_ERROR, error)
      })
  },

  get({commit, state, rootGetters}, data) {
    commit(types.SET_PROJECT_DOWNLOADS_LOADING)
    return fetch(data.user + '/project_downloads' + data.urlParams + '&project.id=' + data.projectId)
      .then(response => response.json())
      .then((data) => {
        commit(types.SET_PROJECT_DOWNLOADS, data['hydra:member'])
        return data
      })
      .catch((error) => {
        commit(types.SET_PROJECT_DOWNLOADS_ERROR, error)
      })
  },
}

const types = {
  SET_PROJECT_DOWNLOADS_LOADING: 'SET_PROJECT_DOWNLOADS_LOADING',
  SET_PROJECT_DOWNLOADS: 'SET_PROJECT_DOWNLOADS',
  SET_PROJECT_DOWNLOADS_ERROR: 'SET_PROJECT_DOWNLOADS_ERROR',
  RESET: 'RESET',
}

const mutations = {
  [types.SET_PROJECT_DOWNLOADS_LOADING](state) {
    state.isLoading = true;
  },
  [types.SET_PROJECT_DOWNLOADS](state, projectDownloads) {
    state.projectDownloads = projectDownloads
    state.isLoading = false
  },
  [types.SET_PROJECT_DOWNLOADS_ERROR](state, error) {
    state.error = error;
    state.isLoading = false;
  },
  [types.RESET](state) {
    Object.assign(state, getInitialState());
  },
}

export default {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
}
